export enum ComponentType {
    Input = 'Input',
    Textarea = 'Textarea',
    Select = 'Select',
    SpecialRequests = 'SpecialRequests',
    MarketingPreferences = 'MarketingPreferences',
    HeaderIntro = 'HeaderIntro',
    Image = 'Image',
    LocationBlock = 'LocationBlock',
    ActionableButton = 'ActionableButton',
    SubmitButton = 'SubmitButton',
    Navigator = 'Navigator',
    Date = 'Date',
    Time = 'Time',
    RichText = 'RichText',
    MobileInput = 'MobileInput',
    Dropdown = 'Dropdown',
    SideInfo = 'SideInfo',
    Loader = 'Loader',
    Confirmation = 'Confirmation',
    Whatsapp = 'Whatsapp',
    DateTime = 'DateTime',
    ErrorBanner = 'ErrorBanner',
}
